/* 
 * To change this license header, choose License Headers in Project Properties.
 * To change this template file, choose Tools | Templates
 * and open the template in the editor.
 */

import { nextTick } from 'vue'
import { createI18n } from "vue-i18n";

export const i18n = createI18n({
    globalInjection: true,
    locale: window.langKey,
    fallbackLocale: 'en',
    messages: {
    },
    numberFormats: {
        'en': {
            currency: {
                style: 'currency',
                currency: 'EUR'
                ,currencyDisplay: 'symbol'
            }
        },
        'de': {
            currency: {
                style: 'currency',
                currency: 'EUR'
                ,currencyDisplay: 'symbol'
            }
        }
        ,'tr': {
            currency: {
                style: 'currency',
                currency: 'EUR'
//                ,currencyDisplay: 'symbol'
            }
        }
    }
});

export const loadedLanguages = [];

export function setI18nLanguage (lang) {
//    console.log('setI18nLanguage:lang',lang);
    i18n.global.locale = lang;
    axios.defaults.headers.common['Accept-Language'] = lang;
    document.querySelector('html').setAttribute('lang', lang);
//                    this.$i18n.locale = locale;
    window.langKey = lang;
    localStorage.setItem('selectedLang', lang);
    return lang;
}

export function loadLanguageAsync (lang) {
    if (typeof lang === 'undefined' && typeof window.langKey !== 'undefined' && window.langKey.length > 0) {
        lang = window.langKey;
    }
    if (typeof lang === 'undefined') {
        lang = window.navigator.userLanguage || window.navigator.language;
        lang = lang.slice(0,2);
    }
    if (loadedLanguages.includes(lang)) {
        if (i18n.global.locale !== lang){
            setI18nLanguage(lang);
        }
        return Promise.resolve();
    }
    return fetch('/locales/'+lang+'.json')
        .then(response => response.json())
        .then(msgs  => {
            loadedLanguages.push(lang);
            i18n.global.setLocaleMessage(lang, msgs);
            return setI18nLanguage(lang);
            }
        );
}

export function loadLoginAsync (lang) {
//    console.log('lang1',lang);
    
    if (typeof lang === 'undefined') {
        /** When Language is not set, use entry in localstorage **/
        if(localStorage.getItem('selectedLang')){
            lang = localStorage.getItem('selectedLang');
        }else{ /** When no entry in localstorage, use Browser-Setting **/
            lang = window.navigator.userLanguage || window.navigator.language;
            lang = lang.slice(0,2);
        }
    }
//    console.log('lang2',lang);
    if(typeof lang !== 'undefined'){
        window.langKey = lang;
    }
    // still no lang set, use default language:
    if (typeof lang === 'undefined' && typeof window.langKey !== 'undefined' && window.langKey.length > 0) {
        lang = window.langKey;
    }
//    console.log('lang3',lang);
    if (loadedLanguages.includes(lang)) {
//        console.log('language is already loaded',lang);
        if (i18n.global.locale !== lang){
            setI18nLanguage(lang);
        }
        return Promise.resolve();
    }
    return fetch('/locales/'+lang+'/login.json')
        .then(response => response.json())
        .then(msgs  => {
            loadedLanguages.push(lang);
            i18n.global.setLocaleMessage(lang, msgs);
            return setI18nLanguage(lang);
            }
        );
}
